import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { path: '/', label: 'Начало' },
  { path: '/properties', label: 'Имоти' },
  { path: '/news', label: 'Анализи' },
  { path: '/services', label: 'Услуги' },
  { path: '/about', label: 'За нас' },
  { path: '/contact', label: 'Контакти' }];


  const isActive = (path) => location.pathname === path;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-[#0B0B0B]/95 backdrop-blur-md shadow-lg shadow-[#D4AF37]/5' : 'bg-transparent'}`
      }>

      <div className="container-luxury">
        <div className="flex items-center justify-between h-20 lg:h-24">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 group">
            <img
              src="/images/deus-logo.png"
              alt="Deus Estate"
              className="h-20 lg:h-16 w-auto transition-transform duration-300 group-hover:scale-105 !rounded-[1px]" />

          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium tracking-wide transition-colors duration-300 relative group ${
              isActive(link.path) ? 'text-[#D4AF37]' : 'text-[#F6F2E8] hover:text-[#D4AF37]'}`
              }>

                {link.label}
                <span className={`absolute bottom-0 left-0 w-full h-0.5 bg-[#D4AF37] transform origin-left transition-transform duration-300 ${
              isActive(link.path) ? 'scale-x-100' : 'scale-x-0 group-hover:scale-x-100'}`
              }></span>
              </Link>
            )}
          </nav>

          {/* CTA Button */}
          <Link to="/contact" className="hidden lg:block btn-primary">
            Консултация
          </Link>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-[#D4AF37] hover:bg-[#D4AF37]/10 rounded-md transition-colors duration-300"
            aria-label="Toggle menu">

            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen &&
      <div className="lg:hidden bg-[#111111] border-t border-[#D4AF37]/20">
          <nav className="container-luxury py-6 space-y-4">
            {navLinks.map((link) =>
          <Link
            key={link.path}
            to={link.path}
            onClick={() => setIsMobileMenuOpen(false)}
            className={`block text-base font-medium py-2 transition-colors duration-300 ${
            isActive(link.path) ? 'text-[#D4AF37]' : 'text-[#F6F2E8] hover:text-[#D4AF37]'}`
            }>

                {link.label}
              </Link>
          )}
            <Link
            to="/contact"
            onClick={() => setIsMobileMenuOpen(false)}
            className="block btn-primary text-center mt-4">

              Консултация
            </Link>
          </nav>
        </div>
      }
    </header>);

};

export default Header;